import { Gmail, Whatsapp } from "@boxicons/react";

export function Efooter() {
    const handleRedirect = () => {
        window.location.href = 'mailto:contacto@anfro.com.mx?subject=Asunto&body=Cuerpo%20del%20mensaje';
    };
    const handleRedirectWhatsapp = () => {
        window.location.href = 'https://wa.me/+3331587544?text=Hola!';
      };
    return (
        <section className="footer">
            <section className="top">
                <div className="logo-box">
                    <img src='/images/logos/logo-empresa.jpg' width={180} alt="logo ABP"></img>
                </div>
                <div className="about-abp-box">
                    <h2>About us</h2>
                    <div className="list">
                        <ul>
                            <li>
                                Development for medium-term infrastructure project investment.
                            </li>
                            <li>
                                Consulting in the air conditioning systems sector.
                            </li>
                            <li>
                                Installation of industrial air conditioning systems in industrial plants.
                            </li>
                        </ul>
                        <ul>
                            <li>
                                Preparation, management, and consulting in industrial and commercial projects.
                            </li>
                            <li>
                                Detection of specialized labor.
                            </li>
                            <li>
                                Supply of materials in the industrial sector.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="social-media">
                    <h2>Get in contact!</h2>
                    <div className="icon-box" onClick={handleRedirect}>
                        <Gmail className="i-footer" fill="red" size="lg"/>
                    </div>
                    <div className="icon-box" onClick={handleRedirectWhatsapp}>
                        <Whatsapp className="i-footer"  fill="#fff" size="lg"/>
                    </div>
                </div>
            </section>
            <section className="bottom">
                <h3>© 2026 Anfro - administradora de negocios S de RL de CV</h3>
            </section>
        </section>
    )
}